// Integration Types
export const PARTNERSTACK = 'partnerstack';
export const GONG = 'gong';

export const ATTRIBUTION_ACTIVITY = 'attribution_activity';
export const POPULATION_MOVEMENT = 'population_movement';
export const OVERLAP_MOVEMENT = 'overlap_movement';
export const SALES_EDGE_ACTIVITY = 'sales_edge_activity';
export const INTEGRATIONS = 'integrations';
export const CROSSBEAM = 'crossbeam';
export const COPILOT_ACTIVITY = 'copilot';
export const USER_RESEARCHED_CONTACT = 'user_researched_contact';
export const USER_RESEARCHED_ACCOUNT = 'user_researched_account';
export const USER_ADDED_CONTACT_TO_CRM = 'user_added_contact_to_crm';
export const LIST_EVENT = 'list_event';
export const LIST_NOTE_ADDED = 'list_note_added';
export const LIST_NOTE_UPDATED = 'list_note_updated';
export const LIST_RECORD_ADDED = 'list_record_added';
export const LIST_RECORD_REMOVED = 'list_record_removed';
export const REPORT_NOTE_ADDED = 'report_note_added';
export const REPORT_OVERLAP_VISIBLE = 'report_overlap_visible';
export const REPORT_SHARED = 'report_shared';
export const REPORT_EVENTS = 'report_events';

export const ALL_EVENT_FILTERS = {
  [ATTRIBUTION_ACTIVITY]: 'all_attribution_activity_filters',
  [POPULATION_MOVEMENT]: 'all_population_movement_filters',
  [OVERLAP_MOVEMENT]: 'all_overlap_movement_filters',
  [SALES_EDGE_ACTIVITY]: 'all_sales_edge_activity_filters',
  [INTEGRATIONS]: 'all_integrations_filters',
  [CROSSBEAM]: 'all_crossbeam_filters',
  [COPILOT_ACTIVITY]: 'all_copilot_filters',
  [LIST_EVENT]: 'all_list_event_filters',
  [REPORT_EVENTS]: 'all_report_event_filters',
};

// Event type categories and their individual events for tree filters
export const TIMELINE_EVENT_TYPES = {
  overlap_movement: {
    label: 'Overlap Movement',
    children: {
      overlap_entry: 'Overlap Entry',
      overlap_exit: 'Overlap Exit',
    },
  },
  population_movement: {
    label: 'Population Movement',
    children: {
      population_entry: 'Population Entry',
      population_exit: 'Population Exit',
    },
  },
  attribution_activity: {
    label: 'Attribution',
    children: {
      attribution_created: 'Attribution Created',
      attribution_updated: 'Attribution Updated',
      attribution_deleted: 'Attribution Deleted',
    },
  },
  sales_edge_activity: {
    label: 'Crossbeam for Sales',
    children: {
      request_sent: 'Outgoing Message',
      request_received: 'Incoming Message',
    },
  },
  list_events: {
    label: 'Shared Lists',
    children: {
      list_note_added: 'List Note Added',
      list_note_updated: 'List Note Updated',
      list_record_added: 'List Record Added',
      list_record_removed: 'List Record Removed',
    },
  },
  report_events: {
    label: 'Dynamic Shared Lists',
    children: {
      report_note_added: 'Note Added',
      report_overlap_visible: 'Account Appeared in List',
      report_shared: 'List Shared',
    },
  },
  integrations: {
    label: 'Integrations',
    children: {
      partner_mention: 'Partner Mention',
      partnerstack_lead_created: 'PartnerStack Lead',
    },
  },
  user_activity: {
    label: 'User Activity',
    children: {
      user_added_contact_to_crm: 'Added Contact to CRM',
      user_clicked_contacts_tab: 'Researched Contact',
      user_clicked_linkedin: 'Clicked LinkedIn',
      user_copied_email: 'Copied Email',
      user_copied_phone: 'Copied Phone',
      user_clicked_account_tab: 'Researched Account',
      user_clicked_play_details: 'Clicked Play Details',
      user_clicked_partners_tab: 'Clicked Partners Tab',
    },
  },
};

// Mapping from individual event types to their categories
export const EVENT_TYPE_LOOKUP = {
  partner_mention: 'integrations',
  partnerstack_lead_created: 'integrations',
  attribution_created: 'attribution_activity',
  attribution_updated: 'attribution_activity',
  attribution_deleted: 'attribution_activity',
  overlap_entry: 'overlap_movement',
  overlap_exit: 'overlap_movement',
  population_entry: 'population_movement',
  population_exit: 'population_movement',
  request_received: 'sales_edge_activity',
  request_sent: 'sales_edge_activity',
  user_added_contact_to_crm: 'user_activity',
  user_clicked_contacts_tab: 'user_activity',
  user_clicked_linkedin: 'user_activity',
  user_copied_email: 'user_activity',
  user_copied_phone: 'user_activity',
  user_clicked_account_tab: 'user_activity',
  user_clicked_play_details: 'user_activity',
  user_clicked_partners_tab: 'user_activity',
  list_note_added: 'list_events',
  list_note_updated: 'list_events',
  list_record_added: 'list_events',
  list_record_removed: 'list_events',
  report_note_added: 'report_events',
  report_overlap_visible: 'report_events',
  report_shared: 'report_events',
};
